export const environment = {
    name: 'development',
    production: false,
    API_BASE_PATH: 'https://ffsj-censo-api-dev-spc.azurewebsites.net/emjf1/Censo-Hogueras/1.0.0',
    FILES_BASE_PATH: 'https://files.censo.hogueras.es/uploads'
};
